import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { translations } from "@/lib/translations";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("tf_lang") || "da");

  useEffect(() => {
    localStorage.setItem("tf_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key, vars) => {
    const dict = translations[lang] || translations.da;
    let str = dict[key] ?? translations.en[key] ?? key;
    if (vars) {
      for (const k of Object.keys(vars)) {
        str = str.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k]));
      }
    }
    return str;
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l), []);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
